export const DEBOUNCE_DELAY = 500;
export const MAX_FILE_SIZE_KB = 1024;
export const fileSizeInKB = (file: File) => {
  return file.size / 1024;
};
